import React from "react";
import joinImage from "../images/intend-join-end-arrows.png";
import arrowBlue from "../images/arrow-blue.png";
import arrowGreen from "../images/arrow-green.png";
import styles from './JoinUnion.module.scss';

const UnionForm = (props) => {
  const { setMemberData, setChoicesData, joinUnion, email, phone, role, unionName, doNotPass, doNotJoin, noJoinNoPass } = props;

  const onCheckboxChange = (e) => {
    setChoicesData({ name: e.target.name, value: e.target.checked });
  };
  
  const onTextChange = (e) => {
    setMemberData({ name: e.target.name, value: e.target.value });
  };

    return (
        <div className="container">
          <div className="row text-center"><img src={joinImage} alt="join or not join"></img></div>
          <div className="row">
            <div className="col-md-6">
              <div className={`${styles.borderBox} ${styles.lightGreen}`}>
                <h5>Join a Union</h5>
                
                <div className="form-group d-flex align-items-center mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="joinUnion"
                    name="joinUnion"
                    value={joinUnion}
                    onChange={onCheckboxChange}
                  />
                  <label className="form-check-label ml-2" htmlFor="joinUnion">
                    Yes, I intend to join a union.
                  </label>
                </div>
    
                <div className="form-group d-flex align-items-center mb-3">
                  <label htmlFor="email" className="mb-0 mr-2">Email:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={onTextChange}
                    className="form-control"
                    max={40}
                  />
                </div>
    
                <div className="form-group d-flex align-items-center mb-3">
                  <label htmlFor="phone" className="mb-0 mr-2">Phone (optional):</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-control"
                    value={phone}
                    onChange={onTextChange}
                    maxLength={12}
                  />
                </div>
    
                <div className="form-group d-flex align-items-center mb-3">
                  <label htmlFor="role" className="mb-0 mr-2">Role (optional):</label>
                  <input
                    type="text"
                    id="role"
                    name="role"
                    className="form-control"
                    value={role}
                    onChange={onTextChange}
                    maxLength={40}
                  />
                </div>
    
                <div className="form-group d-flex align-items-center mb-3">
                  <label htmlFor="unionName" className="mb-0 mr-2">The union I intend to join is:</label>
                  <input
                    type="text"
                    id="unionName"
                    name="unionName"
                    className="form-control"
                    value={unionName}
                    onChange={onTextChange}
                  />
                </div>
    
                <div className="form-check d-flex align-items-center mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="doNotPass"
                    name="doNotPass"
                    value={doNotPass}
                    onChange={onCheckboxChange}
                  />
                  <label className="form-check-label ml-2" htmlFor="doNotPass">
                    Tick this box if you do not want this form passed on to any other unions that cover your work.
                  </label>
                </div>
    
                <p className="mt-3">
                  Joining the union will allow you to continue your role under a Collective Agreement.
                </p>
              </div>
              <div className="row text-center">
                <img src={arrowGreen} alt="greem arrow"></img>
              </div>
              <div className="text-center">
                <div className={`${styles.borderBox} ${styles.lightGreen}`}>
                  <p>If you chose to join a union, your employer will pass this form onto them, and your membership will be processed by the union.</p>
                  <p>If you are not sure how to contact a union, you can talk to a union representative at your workplace or visit the New Zealand Council of Trade Unions: <a href="http://union.org.nz" target="_blank" rel="noopener noreferrer">union.org.nz</a></p>
                </div>
              </div>
            </div>
    
            <div className="col-md-6">
              <div className={`${styles.borderBox} ${styles.lightBlue}`}>
                <h5>What if I do not intend to join a union?</h5>
                <p>
                  If you do not intend to join a union, you will move to an Individual Employment Agreement after your first 30 days of employment and will no longer be covered by the Collective Agreement terms.
                </p>
                <p>
                  An individual employment agreement contains terms and conditions agreed between employee and employer.
                </p>
              </div>
              <div className="row text-center">
                <img src={arrowBlue} alt="blue arrow"></img>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className={`${styles.borderBox} ${styles.lightBlue}`}>
                    <div className="form-check d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="noJoinUnion"
                        name="noJoinUnion"
                        value={doNotJoin}
                        onChange={onCheckboxChange}
                      />
                      <label className="form-check-label ml-2" htmlFor="noJoinUnion">
                        No, I do not intend to join a union.
                      </label>
                    </div>
    
                    <div className="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="noJoinNoPass"
                        name="noJoinNoPass"
                        value={noJoinNoPass}
                        onChange={onCheckboxChange}
                      />
                      <label className="form-check-label ml-2" htmlFor="noJoinNoPass">
                        Tick this box if you do not want this form passed on to the unions that cover your work.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
    
    export default UnionForm;